import React from "react";
import BarcodeReader from 'react-barcode-reader';
import {
  Modal,
  Input,
  Form,
  Select,
  Icon,
  DatePicker,
  Tabs,
  Button,
  Tag,
  Checkbox,
  Tooltip
} from "antd";
import {
  GUIA_TRANSPORTISTA
} from "../../../common/types/tipoComprobanteType";

import moment from "moment";
import auth from "../../../common/utility/auth";
import global from "../../../common/utility/global";
import "./styles.css";
import {
  FORMAT_3DECIMALS,
  GREATER_THAN_ZERO,
} from "../../../common/types/regularExpresionType";
import { REGISTRADO } from "../../../common/types/guiaRemisionEstadoType";
import DetalleProductoServicioModal from "./FormModal/DetalleProductoServicioModal";
import DetalleReferenciaModal from "./FormModal/DetalleReferenciaModal";
import DetalleVehiculoModal from "./FormModal/DetalleVehiculoModal";
import DetalleChoferModal from "./FormModal/DetalleChoferModal";

import dialog from "../../../common/utility/dialog";
import { VENTA_DECIMAL } from "../../../common/types/parametroType";

const InputGroup = Input.Group;
const { Search } = Input;
const { Option } = Select;
const { TabPane } = Tabs;

class FormModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.handleScan = this.handleScan.bind(this)
  }


  handleRemoverProducto = (row) => {
    var detalleProductos = this.props.formValues.listaComprobanteDetalle;
    var detalleProductosFilter = detalleProductos.filter((m) => {
      return m.identifier !== row.identifier;
    });

    var sumaTotalPeso = this.fetchFieldValueSum(row.identifier, "arrTotalPeso", 0);

    this.props.form.setFieldsValue({
      totalPeso: sumaTotalPeso,
      detalleProductos: detalleProductosFilter
    });

    this.props.onRemoverProducto(row, this.props.form);
  };


  handleCompleteDecimals = (property, value) => {
    if (value === "" || isNaN(parseFloat(value).toFixed(3)))
      this.props.form.setFieldsValue({ [property]: "0.000" });
    else
      this.props.form.setFieldsValue({
        [property]: parseFloat(value).toFixed(3),
      });
  };

  fetchNewValue = (value, numberDecimals) => {
    if (numberDecimals === 2)
      return value === "" || isNaN(parseFloat(value).toFixed(2))
        ? 0
        : parseFloat(value);
    if (numberDecimals === 3)
      return value === "" || isNaN(parseFloat(value).toFixed(3))
        ? 0
        : parseFloat(value);
    if (numberDecimals === 5)
      return value === "" || isNaN(parseFloat(value).toFixed(5))
        ? 0
        : parseFloat(value);
    if (numberDecimals === 0)
      return value === "" || isNaN(parseFloat(value).toFixed(0))
        ? 0
        : parseFloat(value);

    return 0;
  };

  handleSearchAutocompleteCliente = async (value) => {
    const result = this.props.formValues.destinatarios
      .filter((item) => {
        return global
          .formatSearch(`${item.nombre} - ${item.tipoDocumento}`)
          .match(global.formatSearch(value));
      })
      .slice(0, 75);
    this.props.form.setFieldsValue({ destinatarios: result });
  };

  handleChangeAutocompleteCliente = (a, element) => {

    this.props.form.setFieldsValue(
      {
        documentoDestinatario: element.props.data.numeroDocumento,
      },
      () => {
        this.props.onChange(
          "idDestinatario",
          element.props.data.id,
          this.props.form
        );
      }
    );
  };

  handleChangeVehiculo = (a, element) => {

    this.props.form.setFieldsValue(
      {
        placaVehiculo: element.props.data.placa,
        marcaVehiculo: element.props.data.marca,
        modeloVehiculo: element.props.data.modelo,
        colorVehiculo: element.props.data.color,
        tuc: element.props.data.tuc
      }
    );
  };

  handleChangeIndicador = (a, element) => {
    this.props.form.setFieldsValue({
      flagTercero: element.props.data == "IT" ? true : false,
      flagSubcontrato: element.props.data == "IS" ? true : false,

    });
  };


  handleScan(data) {

    this.props.onScanerProduct(data,
      this.props.form.setFieldsValue,
      this.props.form.getFieldValue);
  }

  handleError(err) {
    alert('error');
    console.error(err)
  }

  fetchFieldValue = (identifier, property) => {
    var result = parseFloat(
      this.props.form.getFieldValue(`${property}[${identifier}]`)
    );
    return result;
  };

  fetchFieldValueSum = (identifier, property, paramValue) => {
    var suma = 0;
    var obj = Object.assign({}, this.props.form.getFieldValue(property));

    for (var [key, value] of Object.entries(obj)) {
      suma = suma + (key === identifier ? paramValue : parseFloat(value));
    }

    return suma;
  };


  handleSearchAutocompleteProveedor = async (value) => {
    const result = this.props.formValues.remitentes
      .filter((item) => {
        return global
          .formatSearch(`${item.nombre} - ${item.tipoDocumento}`)
          .match(global.formatSearch(value));
      })
      .slice(0, 75);
    this.props.form.setFieldsValue({ remitentes: result });
  };

  handleChangeAutocompleteProveedor = (a, element) => {

    this.props.form.setFieldsValue(
      {
        documentoRemitente: element.props.data.numeroDocumento,
      },
      () => {
        this.props.onChange(
          "idRemitente",
          element.props.data.id,
          this.props.form
        );
      }
    );
  };

  handleRemoverChofer = (row) => {

    var choferesSecundarios = this.props.form.getFieldValue("choferesSecundarios");
    var choferesSecundariosFilter = choferesSecundarios.filter((m) => {
      return m.identifier !== row.identifier;
    });

    this.props.form.setFieldsValue({
      choferesSecundarios: choferesSecundariosFilter
    });

    this.props.onRemoveChofer(row, this.props.form);
  };

  handleRemoverVehiculo = (row) => {

    var vehiculosSecundarios = this.props.form.getFieldValue("vehiculosSecundarios");
    var vehiculosSecundariosFilter = vehiculosSecundarios.filter((m) => {
      return m.identifier !== row.identifier;
    });

    this.props.form.setFieldsValue({
      vehiculosSecundarios: vehiculosSecundariosFilter
    });

    this.props.onRemoveVehiculo(row, this.props.form);
  };



  handleCalculateDetail = (index,
    identifier,
    row,
    property,
    value,
    numberDecimals
  ) => {

    var newValue = this.fetchNewValue(value, numberDecimals);
    var params = auth.user().parametros;

    const pesoVenta = auth.user().parametros.filter(m => m.abreviatura === VENTA_DECIMAL)[0].valor === "1" ? 2 : 5;
    const cantidadVenta = auth.user().parametros.filter(m => m.abreviatura === VENTA_DECIMAL)[0].valor === "1" ? 2 : 3;


    /*********** Datos por fila ********/
    var flagAfecto =
      property === "arrFlagAfecto"
        ? value
        : this.props.form.getFieldValue(`arrFlagAfecto[${identifier}]`);
    var cantidad =
      property === "arrCantidad"
        ? newValue
        : this.fetchFieldValue(identifier, "arrCantidad");
    var pesoUnitario =
      property === "arrPesoUnitario"
        ? newValue
        : this.fetchFieldValue(identifier, "arrPesoUnitario");
    var totalPeso =
      property === "arrTotalPeso"
        ? newValue
        : this.fetchFieldValue(identifier, "arrTotalPeso");
    var numeroLote =
      property === "arrLote"
        ? value
        : this.props.form.getFieldValue(`arrLote[${identifier}]`);


    var idUnidadMedida = 0;

    /*********** Calculo totales ********/

    if (property === "arrTotalPeso") {

      /*********** Calculo totales ********/
      totalPeso = parseFloat(value);

      /*********** Calculo Cantidad ********/
      pesoUnitario = cantidad == 0 ? 0 : parseFloat((totalPeso / cantidad).toFixed(5));

    } else {

      if (totalPeso > 0 && pesoUnitario == 0) {
        pesoUnitario = cantidad == 0 ? 0 : parseFloat((totalPeso / cantidad).toFixed(5));

      } else {
        totalPeso = cantidad * pesoUnitario;
      }

    }
    /*********** Arr Detalle ********/
    var detalle = {
      identifier,
      idProducto: row.idProducto,
      flagAfecto,
      pesoUnitario,
      cantidad,
      nombre: row.nombre,
      totalPeso,
      numeroLote,
      flagConversion: row.flagConversion,
      idUnidadMedida: idUnidadMedida,
    };

    var arrDetalle = this.props.form.getFieldValue("detalleProductos");
    var arrDetalleFilter = arrDetalle.filter((m) => {
      return m.identifier !== identifier;
    });
    arrDetalleFilter.splice(index, 0, detalle);

    var _sumaTotalPeso = 0;
    arrDetalleFilter.forEach((item) => {
      _sumaTotalPeso = _sumaTotalPeso + item.totalPeso;
    });

    /*********** Calculo suma detalle ********/


    this.props.form.setFieldsValue({
      totalPeso: _sumaTotalPeso.toFixed(3),
      detalleProductos: arrDetalleFilter,
      [`arrPesoUnitario[${identifier}]`]: pesoUnitario.toFixed(pesoVenta),
      [`arrCantidad[${identifier}]`]: cantidad.toFixed(cantidadVenta),
      [`arrTotalPeso[${identifier}]`]: totalPeso.toFixed(3)
    });

    this.props.form.setFieldsValue({
      detalleProductos: arrDetalleFilter,
    });
  };

  handleChangeNameProduct = (row) => {
    this.props.onChangeNameProduct(row);
  };


  validate_fechaMayorQue(fechaInicial, fechaFinal) {
    var valuesStart = fechaInicial.split("/");
    var valuesEnd = fechaFinal.split("/");

    // Verificamos que la fecha no sea posterior a la actual
    var dateStart = new Date(valuesStart[2], (valuesStart[1] - 1), valuesStart[0]);
    var dateEnd = new Date(valuesEnd[2], (valuesEnd[1] - 1), valuesEnd[0]);
    if (dateStart > dateEnd) {
      return 0;
    }
    return 1;
  }


  handleChangeChofer = (value, row, identifier) => {

    var _chofer = this.props.form.getFieldValue("idChofer");
    var _repite = false;
    if (_chofer.key == value) {
      dialog.warning("No se puede repetir el Chofer");
      _repite = true;
    }
    var detalle = {
      identifier: global.fetchUniqueCode(),
      idChofer: _repite ? 0 : value,
      licencia: _repite ? '' : row.props.licencia,
      nombres: _repite ? '' : row.props.nombres,
    }

    var arrDetalle = this.props.form.getFieldValue("choferesSecundarios");
    var arrDetalleFilter = arrDetalle.filter((m) => {
      return m.identifier !== identifier;
    });

    arrDetalleFilter.push(detalle);

    this.props.form.setFieldsValue({
      [`idChofer[${identifier}]`]: _repite ? 0 : value,
      [`arrLicencia[${identifier}]`]: _repite ? '' : row.props.licencia,
      choferesSecundarios: arrDetalleFilter
    });
  };



  handleChangePlaca = (value, property, identifier, row) => {
    if (value == "" || value == null) return;

    var _vehiculo = this.props.form.getFieldValue("idVehiculo");

    var idVehiculo = property === "arrnombreVehiculo" ? value
      : this.props.form.getFieldValue(`arrnombreVehiculo[${identifier}]`);

    var tuc = property === "arrTuc" ? value
      : this.props.form.getFieldValue(`arrTuc[${identifier}]`);

    if (_vehiculo.key == idVehiculo) {
      dialog.warning("No se puede repetir el vehículo");
      idVehiculo = 0;
    }
    if (property === "arrTuc") {
      idVehiculo = idVehiculo.key;
    }

    var detalle = {
      identifier: global.fetchUniqueCode(),
      idVehiculo: idVehiculo,
      tuc: tuc,
    }
    var arrDetalle = this.props.form.getFieldValue("vehiculosSecundarios");
    var arrDetalleFilter = arrDetalle.filter((m) => {
      return m.identifier !== identifier;
    });
    arrDetalleFilter.push(detalle);

    this.props.form.setFieldsValue({
      [`arrnombreVehiculo[${identifier}]`]: idVehiculo,
      [`arrTuc[${identifier}]`]: tuc,
      vehiculosSecundarios: arrDetalleFilter,

    });
  };




  handleOk = (e) => {
    e.preventDefault();

    this.props.form.validateFieldsAndScroll((err, values) => {

      if (!err) {

        var params = auth.user().parametros;

        var form = {
          id: values.id,
          idUsuarioRegistro: values.idUsuarioRegistro,
          idTipoComprobante: GUIA_TRANSPORTISTA.ID,
          idGuiaRemisionEstado: REGISTRADO,
          serie: values.serie,
          documento: values.documento,
          fechaStr: values.fechaStr.format("DD/MM/YYYY"),
          fechaTrasladoStr: values.fechaTrasladoStr.format("DD/MM/YYYY"),
          idProyecto: values.idProyecto == null ? 0 : values.idProyecto.key,

          idRemitente: values.idRemitente == null ? 0 : values.idRemitente.key,
          documentoRemitente: values.documentoRemitente == null ? 0 : values.documentoRemitente,

          idDestinatario: values.idDestinatario.key,
          documentoDestinatario: values.documentoDestinatario == null ? 0 : values.documentoDestinatario,

          idEstablecimientoPartida: values.flagEditdireccionPartida ? values.valueEditdireccionPartida : values.idEstablecimientoPartida.key,
          direccionPartida: values.direccionPartida == undefined ? null : values.direccionPartida,
          flagEditdireccionPartida: values.flagEditdireccionPartida,
          idUbigeoOrigen: values.idDistritoPartida.key,

          idEstablecimientoDestino: values.flagEditdireccionDestino ? values.valueEditdireccionDestino : values.idEstablecimientoDestino.key,
          direccionDestino: values.direccionDestino,
          flagEditdireccionDestino: values.flagEditdireccionDestino,
          idUbigeoDestino: values.idDistritoLlegada.key,

          flagTercero: values.flagTercero,
          flagSubcontrato: values.flagSubcontrato,

          flagCategoria: values.flagCategoria,
          flagProgramado: values.flagProgramado,
          flagVehiculoVacio: values.flagVehiculoVacio,
          flagEmbalajeVacio: values.flagEmbalajeVacio,

          nroMtc: values.nroMtc,
          documentoTercero: values.documentoTercero == undefined ? null : values.documentoTercero,
          razonSocialTercero: values.razonSocialTercero == undefined ? null : values.razonSocialTercero,
          idIndicadorSunat: values.idIndicadorSunat.key,
          idChofer: values.idChofer == undefined ? 0 : values.idChofer.key,
          idVehiculo: values.idVehiculo == undefined ? 0 : values.idVehiculo.key,
          licencia: values.licencia,
          tuc: values.tuc,
          observacion: values.observacion,
          porcentajeIGV: 18,
          subTotal: values.sumaSubTotal,
          igv: values.sumaIgv,
          total: values.sumaTotal,
          totalPeso: parseFloat(values.totalPeso),
          guiaTransportistaDetalles: values.detalleProductos,
          guiaTransportistaReferencias: this.fetchReferencias(values),
          guiaTransportistaVehiculo: values.vehiculosSecundarios,
          guiaTransportistaChofer: values.choferesSecundarios

        };

        if (form.totalPeso < 1) {
          dialog.warning("El peso total tiene que ser mayor o igual 1");
          return false;
        }

        if (!this.validate_fechaMayorQue(form.fechaStr, form.fechaTrasladoStr)) {
          dialog.warning("La fecha de traslado debe ser mayor o igual que la fecha de emision");
          return false;
        }
        if (values.detalleProductos.length == 0) {
          dialog.warning("Agregar los productos");
          return false;
        }

        this.props.onSave(form, this.props.form);
      }
    });
  };


  fetchReferencias = (values) => {
    var result = [];
    // 
    if (
      values.arrTipoComprobante === undefined ||
      values.arrSerie === undefined ||
      values.arrDocumento === undefined ||
      values.arrIdReferencia === undefined ||
      values.arrIdReferenciaOrigen === undefined
    )
      return result;

    var keys = [];
    var obj = Object.assign({}, values.arrTipoComprobante);

    for (var [key] of Object.entries(obj)) {
      keys.push(key);
    }
    keys.forEach((key) => {
      result.push({
        id: 0,
        idGuiaRemision: 0,
        idTipoComprobante: values.arrTipoComprobante[key].key,
        serie: values.arrSerie[key],
        documento: values.arrDocumento[key],
        idReferencia: values.arrIdReferencia[key],
        idReferenciaOrigen: values.arrIdReferenciaOrigen[key],

      });
    });

    return result;
  };

  displaySizeObservacion = () => {
    var result = false;

    var flagTercero = this.props.form.getFieldValue("flagTercero");
    var flagSubcontrato = this.props.form.getFieldValue("flagSubcontrato");
    if (flagTercero) {
      result = true;
    } else {
      if (flagSubcontrato) {
        result = true;
      }
    }
    return result;
  };

  handleEditDireccionDestino = () => {
    var idEstablecimientoClienteEdit = this.props.form.getFieldValue("idEstablecimientoDestino").key;
    var _varios = this.props.formValues.direccionesLlegadas.filter((m) => m.id === idEstablecimientoClienteEdit);

    this.props.form.setFieldsValue({
      flagEditdireccionDestino: true,
      direccionLlegada: _varios.length > 0 ? _varios[0].nombre + " - " + _varios[0].direccion : ''
    });

  };

  handleEditDireccionPartida = () => {
    var idEstablecimientoClienteEdit = this.props.form.getFieldValue("idEstablecimientoPartida").key;
    var _varios = this.props.formValues.direccionesPartidas.filter((m) => m.id === idEstablecimientoClienteEdit);

    this.props.form.setFieldsValue({
      flagEditdireccionPartida: true,
      valueEditdireccionPartida: idEstablecimientoClienteEdit,
      direccionPartida: _varios.length > 0 ? _varios[0].nombre + " - " + _varios[0].direccion : ''
    });

  };

  handleCancel = () => {
    this.props.onClose();
    this.props.form.resetFields();
  };

  render() {
    const {
      getFieldDecorator,
      setFieldsValue,
      getFieldValue,
    } = this.props.form;

    getFieldDecorator("destinatarios", {
      initialValue: this.props.formValues.destinatarios.filter((m) => {
        return m.id === this.props.formValues.idDestinatario;
      }),
    });

    getFieldDecorator("remitentes", {
      initialValue: this.props.formValues.remitentes.filter((m) => {
        return m.id === this.props.formValues.idRemitente;
      }),
    });

    getFieldDecorator("id", { initialValue: this.props.formValues.id });
    getFieldDecorator("idChofer", { initialValue: this.props.formValues.idChofer });
    getFieldDecorator("detalleProductos", { initialValue: this.props.formValues.detalleProductos });
    getFieldDecorator("arrReferencia", { initialValue: this.props.formValues.listaComprobanteReferencia });
    getFieldDecorator("arrDetalle", { initialValue: this.props.arrDetalle });
    getFieldDecorator("vehiculosSecundarios", { initialValue: this.props.formValues.vehiculosSecundarios });
    getFieldDecorator("choferesSecundarios", { initialValue: this.props.formValues.choferesSecundarios });

    getFieldDecorator("sumaSubTotal", {
      initialValue: this.props.formValues.sumaSubTotal,
    });
    getFieldDecorator("sumaIgv", {
      initialValue: this.props.formValues.sumaIgv,
    });
    getFieldDecorator("sumaTotal", {
      initialValue: this.props.formValues.sumaTotal,
    });
    getFieldDecorator("idUsuarioRegistro", {
      initialValue: this.props.formValues.idUsuarioRegistro,
    });
    getFieldDecorator("direccionPartida", {
      initialValue: this.props.formValues.direccionPartida,
    });
    getFieldDecorator("direccionDestino", {
      initialValue: this.props.formValues.direccionDestino,
    });

    getFieldDecorator("flagEditdireccionPartida", {
      initialValue: this.props.formValues.flagEditdireccionPartida,
    });
    getFieldDecorator("flagEditdireccionDestino", {
      initialValue: this.props.formValues.flagEditdireccionDestino,
    });

    getFieldDecorator("valueEditdireccionPartida", {
      initialValue: 0,
    });
    getFieldDecorator("valueEditdireccionDestino", {
      initialValue: 0,
    });

    getFieldDecorator("flagTercero", {
      initialValue: this.props.formValues.flagTercero,
    });
    getFieldDecorator("flagSubcontrato", {
      initialValue: this.props.formValues.flagSubcontrato,
    });

    getFieldDecorator('flagEditCode', {
      initialValue: this.props.formValues.flagEditCode,

    });

    return (
      <Modal
        title={(<div> {this.props.formValues.id === 0 ? `Registrar Guía de Transportista` : `Modificar Guía de Transportista`}</div>)}
        visible={this.props.visible}
        style={{ top: 30 }}
        cancelText={"Cancelar"}
        okText={"Guardar"}
        onCancel={this.handleCancel}
        onOk={this.handleOk}
        width="1050px"
      >
        <BarcodeReader
          onError={this.handleError}
          onScan={this.handleScan}
        />
        <Form>
          {getFieldDecorator("id", { initialValue: this.props.formValues.id })(
            <input type="hidden" />
          )}

          {getFieldDecorator("idComprobante", {
            initialValue: this.props.formValues.idComprobante,
          })(<input type="hidden" />)}

          <div className="row">
            <div className="col-md-3 form-group">
              <Form.Item label="Serie / Documento">
                <InputGroup compact>
                  <Form.Item style={{ width: "40%" }}>
                    {getFieldDecorator("serie", {
                      initialValue: this.props.formValues.serie,
                      rules: [
                        {
                          required: true,
                          message: "Campo obligatorio.",
                        },
                      ],
                    })(
                      <Input
                        placeholder="Serie"
                        autoComplete="off"
                        className="first-input"
                        disabled={true}
                      />
                    )}
                  </Form.Item>
                  <Form.Item style={{ width: "60%" }}>
                    {getFieldDecorator("documento", {
                      initialValue: this.props.formValues.documento,
                    })(
                      <Input
                        placeholder="Documento"
                        autoComplete="off"
                        className="second-input"
                        disabled={true}
                      />
                    )}
                  </Form.Item>
                </InputGroup>
              </Form.Item>
            </div>
            <div className="col-md-3 form-group">
              <Form.Item label="Fecha">
                <InputGroup compact>
                  <Form.Item style={{ width: "100%" }}>
                    {getFieldDecorator("fechaStr", {
                      initialValue: moment(
                        this.props.formValues.fechaStr,
                        "DD/MM/YYYY"
                      ),
                      rules: [
                        {
                          type: "object",
                          required: true,
                          message: "Requerido",
                        },
                      ],
                    })(
                      <DatePicker
                        className="first-input"
                        placeholder="Seleccione fecha"
                        prefix={
                          <Icon
                            type="filter"
                            style={{ color: "rgba(0,0,0,.25)" }}
                          />
                        }
                        format="DD/MM/YYYY"
                        onChange={(moment, value) =>
                          this.props.onChange(
                            "fechaStr",
                            value,
                            this.props.form
                          )
                        }
                      />
                    )}
                  </Form.Item>

                </InputGroup>
              </Form.Item>
            </div>

            <div className="col-md-3 form-group">
              <Form.Item label="Fecha Traslado">
                <InputGroup compact>
                  <Form.Item style={{ width: "100%" }}>
                    {getFieldDecorator("fechaTrasladoStr", {
                      initialValue: moment(
                        this.props.formValues.fechaTrasladoStr,
                        "DD/MM/YYYY"
                      ),
                      rules: [
                        {
                          type: "object",
                          required: true,
                          message: "Requerido",
                        },
                      ],
                    })(
                      <DatePicker
                        className="first-input"
                        placeholder="Seleccione fecha de traslado"
                        prefix={
                          <Icon
                            type="filter"
                            style={{ color: "rgba(0,0,0,.25)" }}
                          />
                        }
                        format="DD/MM/YYYY"
                      />
                    )}
                  </Form.Item>
                </InputGroup>
              </Form.Item>
            </div>
            <div className="col-md-3 form-group">
              <Form.Item label="Proyecto">
                {getFieldDecorator('idProyecto', {
                  initialValue: this.props.formValues.idProyecto ?
                    { key: this.props.formValues.idProyecto } : -1
                })(
                  <Select showSearch labelInValue
                    placeholder={"Seleccione Proyecto"}
                    optionFilterProp="children"
                    disabled={this.props.formValues.isReadOnly}
                  >
                    <Option key={-1} value={-1}>
                      <span style={{ color: "#bfbfbf" }}>Ninguno</span>
                    </Option>
                    {this.props.formValues.proyectos.map(item => (
                      item.estado ?
                        <Option key={item.id} value={item.id}>{item.nombre}</Option>
                        : null
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>


          </div>
          <div className="row">

            <div className="col-md-3 form-group">
              <Form.Item label="N° Documento">
                <Form.Item>
                  {getFieldDecorator("documentoRemitente", {
                    initialValue: this.props.formValues.documentoRemitente,
                    rules: [
                      {
                        required: true,
                        message: "Campo obligatorio.",
                        whitespace: true,
                      },
                    ],
                  })(
                    <Search
                      placeholder="Documento"
                      className="first-input"
                      autoComplete="off"
                      loading={this.props.formValues.remitenteLoading}
                      onSearch={(value) =>
                        this.props.onBuscarRemitente(value, this.props.form)
                      }
                      maxLength={20}
                    />
                  )}
                </Form.Item>

              </Form.Item>
            </div>
            <div className="col-md-9 form-group">
              <Form.Item label="Remitente">
                <Form.Item>
                  <InputGroup compact style={{ marginBottom: "1px" }}>
                    {getFieldDecorator("idRemitente", {
                      initialValue: this.props.formValues.idRemitente
                        ? { key: this.props.formValues.idRemitente }
                        : undefined,
                      rules: [
                        {
                          required: true,
                          message: "Campo obligatorio.",
                        },
                      ],
                    })(
                      <Select
                        showSearch
                        labelInValue

                        placeholder={"Búsqueda de Remitente"}
                        optionFilterProp="children"
                        showArrow={false}
                        onSearch={this.handleSearchAutocompleteProveedor}
                        onChange={this.handleChangeAutocompleteProveedor}
                      >
                        {getFieldValue("remitentes").map((item) => (
                          <Option key={item.id} value={item.id} data={item}>
                            <Tag>{item.tipoDocumentoNombre}</Tag>
                            {`${item.nombre}`}
                          </Option>
                        ))}
                      </Select>
                    )}

                  </InputGroup>
                </Form.Item>
              </Form.Item>
            </div>



          </div>

          <div className="row">
            <div className="col-md-3 form-group">
              <Form.Item label="N° Documento">
                <Form.Item>
                  {getFieldDecorator("documentoDestinatario", {
                    initialValue: this.props.formValues.documentoDestinatario,
                    rules: [
                      {
                        required: true,
                        message: "Campo obligatorio.",
                        whitespace: true,
                      },
                    ],
                  })(
                    <Search
                      placeholder="Documento"
                      className="first-input"
                      autoComplete="off"
                      loading={this.props.formValues.destinatarioLoading}
                      onSearch={(value) =>
                        this.props.onBuscarDestinatario(value, this.props.form)
                      }
                      maxLength={20}
                    />
                  )}
                </Form.Item>

              </Form.Item>
            </div>

            <div className="col-md-9 form-group">
              <Form.Item label="Destinatario">
                <Form.Item>
                  <InputGroup compact style={{ marginBottom: "1px" }}>
                    {getFieldDecorator("idDestinatario", {
                      initialValue: this.props.formValues.idDestinatario
                        ? { key: this.props.formValues.idDestinatario }
                        : undefined,
                      rules: [
                        {
                          required: true,
                          message: "Campo obligatorio.",
                        },
                      ],
                    })(
                      <Select
                        showSearch
                        labelInValue
                        placeholder={"Búsqueda de Destinatario"}
                        optionFilterProp="children"
                        showArrow={false}
                        onSearch={this.handleSearchAutocompleteCliente}
                        onChange={this.handleChangeAutocompleteCliente}
                      >
                        {getFieldValue("destinatarios").map((item) => (
                          <Option key={item.id} value={item.id} data={item}>
                            <Tag>{item.tipoDocumentoNombre}</Tag>
                            {`${item.nombre}`}
                          </Option>
                        ))}
                      </Select>
                    )}

                  </InputGroup>
                </Form.Item>

              </Form.Item>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6 form-group">
              <Form.Item label="Dirección Partida">
                <InputGroup compact>
                  <Form.Item style={{ width: "100%" }}>
                    {this.props.form.getFieldValue("flagEditdireccionPartida") ? (
                      <InputGroup compact style={{ marginBottom: "1px" }}>
                        {getFieldDecorator("direccionPartida", {
                          initialValue: this.props.formValues.direccionPartida,
                          rules: [
                            {
                              required: true,
                              message: "Campo obligatorio mayor a 0.00",
                            },
                          ],
                        })(
                          <Input
                            style={{
                              width: `calc(100% - 40px)`,
                              borderTopLeftRadius: "0px",
                            }}
                            placeholder="Ingresar dirección"
                            autoComplete="off"
                          />
                        )}
                        <Button
                          className="btn-autocomplete"
                          style={{ width: "40px", fontSize: "14px" }}
                          icon="close"
                          onClick={() => {
                            this.props.form.setFieldsValue({
                              //idEstablecimientoPartida: undefined,
                              flagEditdireccionPartida: false,
                            });
                          }}
                        />
                      </InputGroup>
                    ) : (
                      <InputGroup compact style={{ marginBottom: "1px" }}>
                        {getFieldDecorator("idEstablecimientoPartida", {
                          initialValue: this.props.formValues
                            .idEstablecimientoPartida
                            ? {
                              key: this.props.formValues
                                .idEstablecimientoPartida,
                            }
                            : undefined,
                          rules: [
                            {
                              required: true,
                              message: "Campo obligatorio.",
                            },
                          ],
                        })(
                          <Select
                            showSearch
                            labelInValue
                            placeholder={"Seleccione Direccion"}
                            style={{
                              width: `calc(100% - 40px)`,
                              borderTopLeftRadius: "0px",
                            }}

                            onChange={(option, row) => {
                              this.props.form.setFieldsValue({
                                direccionPartida: row.props.direccion,
                                valueEditdireccionPartida: option.key,
                                flagEditdireccionPartida: false
                              });
                              this.props.onChange(
                                "idEstablecimientoPartida",
                                option.key,
                                this.props.form
                              );
                            }}
                            optionFilterProp="children"
                          >
                            {this.props.formValues.direccionesPartidas.map((item) => (
                              <Option key={item.id} value={item.id}>
                                {item.nombre}     {item.direccion}
                              </Option>
                            ))}
                          </Select>
                        )}
                        <Button
                          className="btn-autocomplete"
                          style={{ width: "40px", fontSize: "14px" }}
                          icon="edit"
                          disabled={this.props.formValues.direccionesPartidas.length == 0}
                          onClick={this.handleEditDireccionPartida}
                        />
                      </InputGroup>
                    )}
                  </Form.Item>
                </InputGroup>
              </Form.Item>

            </div>

            <div className="col-md-2 form-group">
              <Form.Item label="Departamento">
                {getFieldDecorator("idDepartamentoPartida", {
                  initialValue: this.props.formValues.idDepartamentoPartida
                    ? { key: this.props.formValues.idDepartamentoPartida }
                    : undefined,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"- Seleccione -"}
                    optionFilterProp="children"
                    onChange={(option) => {
                      this.props.form.setFieldsValue({
                        idProvinciaPartida: undefined,
                      });
                      this.props.form.setFieldsValue({
                        idDistritoPartida: undefined,
                      });
                      this.props.onChange("idDepartamentoPartida", option.key);
                    }}
                  >
                    {this.props.formValues.departamentosPartida.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.nombre}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>

            <div className="col-md-2 form-group">
              <Form.Item label="Provincia">
                {getFieldDecorator("idProvinciaPartida", {
                  initialValue: this.props.formValues.idProvinciaPartida
                    ? { key: this.props.formValues.idProvinciaPartida }
                    : undefined,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"- Seleccione -"}
                    optionFilterProp="children"
                    onChange={(option) => {
                      this.props.form.setFieldsValue({
                        idDistritoPartida: undefined,
                      });
                      this.props.onChange("idProvinciaPartida", option.key);
                    }}
                  >
                    {this.props.formValues.provinciasPartida.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.nombre}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>
            <div className="col-md-2 form-group">
              <Form.Item label="Distrito">
                {getFieldDecorator("idDistritoPartida", {
                  initialValue: this.props.formValues.idDistritoPartida
                    ? { key: this.props.formValues.idDistritoPartida }
                    : undefined,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"- Seleccione -"}
                    optionFilterProp="children"
                  >
                    {this.props.formValues.distritosPartida.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.nombre}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6 form-group">
              <Form.Item label="Dirección Llegada">
                <InputGroup compact>
                  <Form.Item style={{ width: "100%" }}>
                    {this.props.form.getFieldValue("flagEditdireccionDestino") ? (
                      <InputGroup compact style={{ marginBottom: "1px" }}>
                        {getFieldDecorator("direccionDestino", {
                          initialValue: this.props.formValues.direccionDestino,
                          rules: [
                            {
                              required: true,
                              message: "Campo obligatorio.",
                            },
                          ]
                        })(
                          <Input
                            placeholder="Ingresar Dirección de llegada"
                            autoComplete="off"
                            style={{
                              width: `calc(100% - 40px)`,
                              borderTopLeftRadius: "0px",
                            }}
                          />
                        )}
                        <Button
                          className="btn-autocomplete"
                          style={{ width: "40px", fontSize: "14px" }}
                          icon="close"
                          onClick={() => {
                            this.props.form.setFieldsValue({
                              //idEstablecimientoDestino: undefined,
                              flagEditdireccionDestino: false,
                            });
                          }}
                        />
                      </InputGroup>
                    ) : (
                      <InputGroup compact style={{ marginBottom: "1px" }}>
                        {getFieldDecorator("idEstablecimientoDestino", {
                          initialValue: this.props.formValues
                            .idEstablecimientoDestino
                            ? {
                              key: this.props.formValues.idEstablecimientoDestino,
                            }
                            : undefined,
                          rules: [
                            {
                              required: true,
                              message: "Campo obligatorio.",
                            },
                          ],
                        })(
                          <Select
                            showSearch
                            labelInValue
                            placeholder={"Seleccione Direccion"}
                            style={{
                              width: `calc(100% - 40px)`,
                              borderTopLeftRadius: "0px",
                            }}
                            onChange={(option, row) => {
                              this.props.form.setFieldsValue({
                                direccionDestino: row.props.data.nombre + '-' + row.props.data.direccion,
                                valueEditdireccionDestino: option.key,
                                flagEditdireccionDestino: false
                              });
                              this.props.onChange("idEstablecimientoDestino", option.key, this.props.form);
                            }}
                            optionFilterProp="children"
                          >
                            {this.props.formValues.direccionesLlegadas.map((item) => (
                              <Option key={item.id} value={item.id} data={item}>
                                {item.nombre} {item.direccion}
                              </Option>
                            ))}
                          </Select>
                        )}
                        <Button
                          className="btn-autocomplete"
                          style={{ width: "40px", fontSize: "14px" }}
                          icon="edit"
                          disabled={this.props.formValues.direccionesLlegadas.length == 0}
                          onClick={this.handleEditDireccionDestino}
                        />
                      </InputGroup>
                    )}
                  </Form.Item>
                </InputGroup>
              </Form.Item>

            </div>
            <div className="col-md-2 form-group">
              <Form.Item label="Departamento">
                {getFieldDecorator("idDepartamentoLlegada", {
                  initialValue: this.props.formValues.idDepartamentoLlegada
                    ? { key: this.props.formValues.idDepartamentoLlegada }
                    : undefined,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"- Seleccione -"}
                    optionFilterProp="children"
                    onChange={(option) => {

                      this.props.form.setFieldsValue({
                        idProvinciaLlegada: undefined,
                      });
                      this.props.form.setFieldsValue({
                        idDistritoLlegada: undefined,
                      });
                      this.props.onChange("idDepartamentoLlegada", option.key);
                    }}
                  >
                    {this.props.formValues.departamentosLlegada.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.nombre}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>
            <div className="col-md-2 form-group">
              <Form.Item label="Provincia">
                {getFieldDecorator("idProvinciaLlegada", {
                  initialValue: this.props.formValues.idProvinciaLlegada
                    ? { key: this.props.formValues.idProvinciaLlegada }
                    : undefined,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"- Seleccione -"}
                    optionFilterProp="children"
                    onChange={(option) => {
                      this.props.form.setFieldsValue({
                        idDistritoLlegada: undefined,
                      });
                      this.props.onChange("idProvinciaLlegada", option.key);
                    }}
                  >
                    {this.props.formValues.provinciasLlegada.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.nombre}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>
            <div className="col-md-2 form-group">
              <Form.Item label="Distrito">
                {getFieldDecorator("idDistritoLlegada", {
                  initialValue: this.props.formValues.idDistritoLlegada
                    ? { key: this.props.formValues.idDistritoLlegada }
                    : undefined,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"- Seleccione -"}
                    optionFilterProp="children"
                  >
                    {this.props.formValues.distritosLlegada.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.nombre}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>
          </div>

          <div className="row">
            <div
              className="col-md-6 form-group"
            >
              <Form.Item label="Chofer">
                {getFieldDecorator("idChofer", {
                  initialValue: this.props.formValues.idChofer
                    ? { key: this.props.formValues.idChofer }
                    : undefined,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"Seleccione Chofer"}
                    optionFilterProp="children"
                    onChange={(option) => {
                      this.props.form.setFieldsValue({ idVehiculo: undefined });
                      this.props.onChange(
                        "idChofer",
                        option.key,
                        this.props.form
                      );
                    }}
                  >
                    {this.props.formValues.choferes.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.numeroDocumento}-{item.razonSocial}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>

            <div className="col-md-3 form-group">
              <Form.Item label="Licencia">
                {getFieldDecorator("licencia", {
                  initialValue: this.props.formValues.licencia,
                })(
                  <Input
                    placeholder=" licencia"
                    autoComplete="off"
                    disabled={true}
                    className="second-input"
                  />
                )}
              </Form.Item>
            </div>



            <div className="col-md-3 form-group">
              <Form.Item label="Vehículo">
                {getFieldDecorator("idVehiculo", {
                  initialValue: this.props.formValues.idVehiculo
                    ? { key: this.props.formValues.idVehiculo }
                    : undefined,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"Seleccione Vehículo"}
                    optionFilterProp="children"
                    onChange={this.handleChangeVehiculo}
                  >
                    {this.props.formValues.vehiculos.map((item) => (
                      <Option key={item.id} value={item.id} data={item}>
                        {item.placa} ({item.marca}-{item.modelo}-{item.color})
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>

            <div className="col-md-6 form-group">
              <Form.Item label="Indicador de envío SUNAT">
                {getFieldDecorator('idIndicadorSunat', {
                  initialValue: this.props.formValues.idIndicadorSunat ?
                    { key: this.props.formValues.idIndicadorSunat } : undefined
                })(
                  <Select showSearch labelInValue
                    placeholder={"Seleccione Proyecto"}
                    optionFilterProp="children"
                    onChange={this.handleChangeIndicador}
                  >
                    {this.props.formValues.indicadorSunat.map(item => (
                      <Option data={item.abreviatura} key={item.id} value={item.id}>{item.nombre}</Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>
            <div className="col-md-3 form-group">
              <Form.Item label="Tarjeta Única de Circulación (TUC)">
                {getFieldDecorator("tuc", {
                  initialValue: this.props.formValues.tuc,
                })(
                  <Input
                    placeholder="Número TUC"
                    autoComplete="off"
                    className="second-input"
                  />
                )}
              </Form.Item>
            </div>

            <div className="col-md-3 form-group">
              <Form.Item label="Nº de Registro MTC">
                {getFieldDecorator("nroMtc", {
                  initialValue: this.props.formValues.nroMtc,
                })(
                  <Input
                    placeholder="Número MTC"
                    autoComplete="off"
                    className="second-input"
                  />
                )}
              </Form.Item>
            </div>
          </div>

          {this.displaySizeObservacion() ?
            <div className="row">
              <div className="col-md-3 form-group">
                <Form.Item label="N° Documento">
                  <Form.Item>
                    {getFieldDecorator("documentoTercero", {
                      initialValue: this.props.formValues.documentoTercero,
                      rules: [
                        {
                          required: true,
                          message: "Campo obligatorio.",
                          whitespace: true,
                        },
                      ],
                    })(
                      <Search
                        placeholder="Documento"
                        className="first-input"
                        autoComplete="off"
                        loading={this.props.formValues.remitenteLoading}
                        onSearch={(value) =>
                          this.props.onBuscarTercero(value, this.props.form)
                        }
                        maxLength={20}
                      />
                    )}
                  </Form.Item>

                </Form.Item>
              </div>

              <div className="col-md-9 form-group">
                <Form.Item label={this.props.form.getFieldValue("flagTercero") ? "Pagador Servicio Tercero" : "Sub Contratador"}>
                  {getFieldDecorator("razonSocialTercero", {
                    initialValue: this.props.formValues.razonSocialTercero,
                  })(
                    <Input
                      placeholder={this.props.form.getFieldValue("flagTercero") ? "Pagador Servicio Tercero" : "Sub Contratador"}
                      autoComplete="off"
                      readOnly
                      className="second-input"
                    />
                  )}
                </Form.Item>
              </div>

            </div>
            : null
          }


          <div className="row">
            <div className="col-md-12 form-group">
              <Form.Item label="Observación">
                {getFieldDecorator("observacion", {
                  initialValue: this.props.formValues.observacion,
                })(
                  <Input
                    placeholder="Ingresar Observación"
                    autoComplete="off"
                  />
                )}
              </Form.Item>
            </div>



          </div>


          <div className="row">
            <div className="col-md-12 form-group">
              <Tabs
                activeKey={this.props.formValues.activeKey}
                onChange={this.props.onChangeTab}
                tabBarExtraContent={
                  <div className="custom-options">
                    <Button
                      icon="import"
                      type="primary"
                      onClick={() =>
                        this.props.onImportarComprobante(
                          this.props.form.setFieldsValue,
                          this.props.form.getFieldValue
                        )
                      }
                    >
                      Importar Factura / Boleta
                    </Button>


                    <Button
                      icon="plus"
                      type="primary"
                      onClick={() =>
                        this.props.onAgregarDetalle(
                          this.props.form.setFieldsValue,
                          this.props.form.getFieldValue
                        )
                      }
                    >
                      Agregar
                    </Button>

                  </div>
                }
              >
                <TabPane tab="Detalle de Productos" key="1">
                  <DetalleProductoServicioModal
                    dataSource={this.props.formValues.listaComprobanteDetalle}
                    onRemove={this.handleRemoverProducto}
                    onCalculateDetail={this.handleCalculateDetail}
                    onGetFieldDecorator={getFieldDecorator}
                    onGetFieldValue={getFieldValue}
                    onSetFieldsValue={setFieldsValue}
                    onChangeNameProduct={this.handleChangeNameProduct}
                    flagEditCode={this.props.form.getFieldValue("flagEditCode")}

                  />
                </TabPane>
                <TabPane tab="Detalle de Referencias" key="2">
                  <DetalleReferenciaModal
                    dataSource={
                      this.props.formValues.listaComprobanteReferencia
                    }
                    tiposComprobante={this.props.formValues.tiposComprobante}
                    onRemove={this.props.onRemoverReferencia}
                    onGetFieldDecorator={getFieldDecorator}
                  />
                </TabPane>

                <TabPane tab="Vehículo" key="3" disabled={this.props.form.getFieldValue("idVehiculo") == undefined}>
                  <DetalleVehiculoModal
                    dataSource={
                      this.props.form.getFieldValue("vehiculosSecundarios")
                    }
                    onRemove={this.handleRemoverVehiculo}
                    onGetFieldDecorator={getFieldDecorator}
                    onGetFieldValue={getFieldValue}
                    onSetFieldsValue={setFieldsValue}
                    onChangeVehiculo={this.handleChangePlaca}
                    idVehiculo={this.props.form.getFieldValue("idVehiculo")}
                    vehiculos={this.props.formValues.vehiculos}

                  />
                </TabPane>

                <TabPane tab="Chofer" key="4" disabled={this.props.form.getFieldValue("idChofer") == undefined}>
                  <DetalleChoferModal
                    dataSource={this.props.form.getFieldValue("choferesSecundarios")}
                    onChangeChofer={this.handleChangeChofer}

                    choferes={this.props.formValues.choferes}
                    onRemove={this.handleRemoverChofer}
                    onGetFieldDecorator={getFieldDecorator}
                    onGetFieldValue={getFieldValue}
                    onSetFieldsValue={setFieldsValue}
                  />
                </TabPane>
              </Tabs>
            </div>
          </div>

          <div className="row">
            <div className="col-md-9 form-group">
              <div className="row">

                <div className="col-md-6 form-group"  >
                  <Form.Item>

                    {getFieldDecorator("flagProgramado", {
                      initialValue: this.props.formValues.flagProgramado,
                      valuePropName: "checked",
                    })(

                      <Checkbox
                        checked={this.props.formValues.flagProgramado}
                        onChange={(e) => this.props.onChange("flagProgramado", e.target.checked)}
                      >Realizar transbordo programado</Checkbox>

                    )}
                  </Form.Item>
                </div>
                <div className="col-md-6 form-group" >
                  <Form.Item>
                    {getFieldDecorator("flagEmbalajeVacio", {
                      initialValue: this.props.formValues.flagEmbalajeVacio,
                      valuePropName: "checked",
                    })(
                      <Checkbox
                        checked={this.props.formValues.flagEmbalajeVacio}
                        onChange={(e) => this.props.onChange("flagEmbalajeVacio", e.target.checked)}
                      >Retorno de vehículo con envases o embalajes vacios</Checkbox>
                    )}
                  </Form.Item>
                </div>

                <div className="col-md-6 form-group">
                  <Form.Item>
                    {getFieldDecorator("flagCategoria", {
                      initialValue: this.props.formValues.flagCategoria,
                      valuePropName: "checked",
                    })(
                      <Checkbox
                        checked={this.props.formValues.flagCategoria}
                        onChange={(e) => this.props.onChange("flagCategoria", e.target.checked)}
                      > Traslado en vehículos de categoría M1 o L</Checkbox>
                    )}

                  </Form.Item>
                </div>
                <div className="col-md-6 form-group" >
                  <Form.Item>
                    {getFieldDecorator("flagVehiculoVacio", {
                      initialValue: this.props.formValues.flagVehiculoVacio,
                      valuePropName: "checked",
                    })(
                      <Checkbox
                        checked={this.props.formValues.flagVehiculoVacio}
                        onChange={(e) => this.props.onChange("flagVehiculoVacio", e.target.checked)}
                      > Indicador de retorno de vehículo vacío</Checkbox>
                    )}
                  </Form.Item>
                </div>

              </div>

            </div>

            <div className="col-md-3 form-group">
              <Form.Item label="Total Peso (KG)">
                {getFieldDecorator("totalPeso", {
                  initialValue: parseFloat(this.props.formValues.totalPeso).toFixed(
                    2
                  ),
                  rules: [
                    {
                      required: true,
                      pattern: new RegExp(GREATER_THAN_ZERO),
                      message: "Campo obligatorio mayor a 0.00",
                    },
                  ],
                })(
                  <Input
                    className="text-right"
                    placeholder="Ingresar peso total"
                    autoComplete="off"
                    onKeyPress={global.onKeyPressDecimals}
                    disabled={true}
                    onBlur={(e) => {
                      this.props.form.setFieldsValue({
                        totalPeso: global.onBlurDecimals(e, 2),
                      });
                    }}
                  />
                )}
              </Form.Item>
            </div>
          </div>

        </Form>
      </Modal>
    );
  }
}
export default Form.create()(FormModal);
